import { LocalDate } from '@js-joda/core';

import { dateFormatter } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../../translations';

type VisitDateTextViewProps = {
   readonly visitDate: LocalDate;
};

export const VisitDateTextView = (props: VisitDateTextViewProps): JSX.Element => {
   return (
      <TextView testId={'visitDate'} label={invoiceCreateModalTranslationKeys.visitDate}>
         {dateFormatter(props.visitDate)}
      </TextView>
   );
};
